import { CalendarMonth, Info, Notes, Assignment } from "@mui/icons-material";

export const tabs = [
    {
        icon: <Info />,
        entity: "detail",
        label: "Detalhes",
    },
    {
        icon: <Notes />,
        entity: "notes",
        label: "Notas",
    },
    {
        icon: <CalendarMonth />,
        entity: "staff_weekly_hours",
        label: "Horas Semanais",
    },
    {
        icon: <Assignment />,
        entity: "staff_remuneration",
        label: "Remunerações",
    },
  
];
